import { NavLink } from "react-router-dom";
import { ListTodo, Contact, Receipt, FileSignature, CalendarClock, Mail as MailIcon } from "lucide-react";
import { useMail } from "@/context/MailContext";
import { MailBadge } from "@/components/MailBadge";

export const AMM_TABS = [
  { to: "/amministrazione/task", label: "Task", icon: ListTodo, testId: "amm-tab-task" },
  { to: "/amministrazione/anagrafica", label: "Anagrafica", icon: Contact, testId: "amm-tab-anagrafica" },
  { to: "/amministrazione/preventivi", label: "Preventivi", icon: Receipt, testId: "amm-tab-preventivi" },
  { to: "/amministrazione/contratti", label: "Contratti", icon: FileSignature, testId: "amm-tab-contratti" },
  { to: "/amministrazione/scadenze", label: "Scadenze", icon: CalendarClock, testId: "amm-tab-scadenze" },
];

export default function AmmTabs() {
  const { unread } = useMail();
  return (
    <div className="flex items-center gap-2 overflow-x-auto pb-1 -mx-1 px-1" data-testid="amm-tabs">
      {AMM_TABS.map(({ to, label, icon: Icon, testId }) => (
        <NavLink
          key={to}
          to={to}
          data-testid={testId}
          className={({ isActive }) =>
            `flex items-center gap-2 px-4 py-2 rounded-full text-sm whitespace-nowrap transition-colors shrink-0 ${
              isActive
                ? "tp-brand-btn text-white"
                : "text-zinc-400 bg-white/5 hover:bg-white/10 hover:text-white"
            }`
          }
        >
          <Icon size={15} />
          {label}
        </NavLink>
      ))}
      {/* MAIL: sotto-sezione di Amministrazione su tablet/mobile */}
      <NavLink
        to="/mail"
        data-testid="amm-tab-mail"
        className={({ isActive }) =>
          `lg:hidden flex items-center gap-2 px-4 py-2 rounded-full text-sm whitespace-nowrap transition-colors shrink-0 ${
            isActive
              ? "tp-brand-btn text-white"
              : "text-zinc-400 bg-white/5 hover:bg-white/10 hover:text-white"
          }`
        }
      >
        <MailIcon size={15} />
        Mail
        <MailBadge count={unread} testId="amm-tab-mail-badge" />
      </NavLink>
    </div>
  );
}
